import styled from 'styled-components';
import { maxTablet } from 'Utils/utilsStyle';

const Wrapper = styled.div`
  overflow: hidden;
  margin: 0px 0px 50px 0px;
  .person-skeleton-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
   .person-box {
    height: 110px;
    width: 110px;
    border-radius: 50%;
    margin: 0px 3px 0px 3px;
    @media all and (max-width: ${maxTablet}) {
      height: 80px;
      width: 80px;
    }
   }
   .title-box {
    height: 28px;
    border-radius: 25px;
    width: 100px;
    margin-top: -20px;
    margin-bottom: 10px;
    @media all and (max-width: ${maxTablet}) {
      width: 80px;
    }
   }
   .title-box-short{
     width: 125px;
     height: 20px;
     border-radius: 25px;
     margin-bottom: 12px;
     @media all and (max-width: ${maxTablet}) {
      width: 90px;
     }
   }
   .title-box-long{
     width: 150px;
     height: 10px;
     border-radius: 25px;
     margin-bottom: 12px;
     @media all and (max-width: ${maxTablet}) {
      width: 95px;
     }
   }
  }
`;

const BuyerPersonSkeleton = function BuyerPersonSkeleton() {
  return (
    <Wrapper>
      <div className="person-skeleton-wrapper">
        <span className="skeleton-box person-box" />
        <span className="skeleton-box title-box" />
        <span className="skeleton-box title-box-short" />
        <span className="skeleton-box title-box-long" />
      </div>
    </Wrapper>
  );
};

export default BuyerPersonSkeleton;
